import { t } from "@/i18n-js/instance";
import { ListingCard } from "./ListingCard";

interface MemberTagCardProps {
  resources: Array<{ name: string; id: string }>;
}

export const MemberTagListingCard = ({ resources }: MemberTagCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.member_tags")}
    resources={resources}
    emptyStateText={t("help_widget.copilot.chat_card.no_member_tags_found")}
    renderItem={member_tag => member_tag.name}
    getItemKey={member_tag => member_tag.id}
  />
);
